import axios from "axios";  
import { BASE_URL, BASE_URL_BOT } from "../../assets/constant";
import { createHeaders } from "../../utils/Utils";
//! Bot APIs
//TODO: Bot APIs
//  Bot Create
export const getStartedWithBot = async (data) => {
  const headers = createHeaders();
  return await axios.get(`${BASE_URL_BOT}index`,null, headers);
};
//  Bot Create
export const askQuestionWithAIBot = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL_BOT}questions`, data, headers);
};

export const transliterateToHindi = async (text) => {
  try {
    const res = await fetch(
      `https://inputtools.google.com/request?text=${encodeURIComponent(
        text
      )}&itc=hi-t-i0-und&num=1`
    );
    const data = await res.json();
    if (data[0] === "SUCCESS") {
      return data[1][0][1][0]; // return first transliteration
    } else {
      return text; // fallback if failed
    }
  } catch (err) {
    console.error("Transliteration error:", err);
    return text;
  }
};